module.exports = __webpack_public_path__ + "static/media/notification.c2f0b980.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notification.svg
 ** module id = 320
 ** module chunks = 0
 **/